// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav-nav_23a10005","expanded":"Nav-expanded_37794289","divider":"Nav-divider_43c5f2fc","panel":"Nav-panel_f61ae9b6","iconLink":"Nav-iconLink_f5b90b08"};